// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2PTMX","inner":"Form_inner__2cZUR","range":"Form_range__3gBCP","name":"Form_name__3LCPW","actions":"Form_actions__3W2xY"};